import moment from 'moment'

import DatesWFFMDataExchange from '@/services/DatesWFFMDataExchange'

/**
 * A mixin adding dates editing logic and data
 */
export default {
  data () {
    return {
      dx: { dates: new DatesWFFMDataExchange(this.form) },
      popups: { dates: false },
      selectedDates: moment.range(moment(), moment().add(1, 'month')),
      validDates: moment.range(moment(), moment().add(1, 'month')),
    }
  },
  created () {
    // Here...
    this.selectedDates = this.dx.dates.data
  },
  computed: {
    selectedDatesValue () {
      const from = this.selectedDates.start.format('dd DD.MM')
      if (this.validDates.end.isSame(this.selectedDates.end, 'day')) {
        const to = 'do'
        return `${from} - ${to}`
      } else {
        const to = this.selectedDates.end.format('dd DD.MM.YYYY')
        return `${from} - ${to}`
      }
    },
  },
  methods: {
    selectDateFrom (day) {
      this.selectedDates.start = day
    },
    selectDateTo (day) {
      this.selectedDates.end = day
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/Dates.js